import React, { useState, useEffect } from "react";
import FormLayout from "../form-layout";
import Step3No from "./rejection-modal";
import { checkImmediateRed } from "../../lib/eligibility";

export default function Step10B({ formData, setFormData, onBack, goToStep }) {
  const [selection, setSelection] = useState(
    formData.pregnancyNoticeResponse ||
      localStorage.getItem("pregnancyNoticeResponse") ||
      ""
  );

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (selection) {
      localStorage.setItem("pregnancyNoticeResponse", selection);
    }
  }, [selection]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextFormData = { ...formData, pregnancyNoticeResponse: selection };
    setFormData(nextFormData);

    if (checkImmediateRed(nextFormData)) {
      setShowModal(true);
    } else {
      goToStep("additionalInfo");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <FormLayout title="" goToStep={goToStep} onBack={onBack}>
        <h3 className="text-[14px] text-blue-500 font-medium text-center mb-4">
          Important Information
        </h3>

        <p className="text-gray-700 text-sm mb-3 leading-relaxed text-center">
          GLP-1 medications (such as Mounjaro, Wegovy and Nevolat) should not be used during pregnancy
          or while breastfeeding. If you are planning a pregnancy, you must stop using Wegovy at least 2
          months before. You must stop Mounjaro and Nevolat at least one month before attempting to
          conceive. You must contact us if you become pregnant.
        </p>

        <p className="text-gray-700 text-sm mb-3 leading-relaxed text-center">
          Note that Mounjaro may reduce the effectiveness of the oral contraceptive pill. We recommend
          using 2 forms of contraception, such as an IUD/implant as well as barrier contraception (for
          example, condoms) to prevent unplanned pregnancy. Your GP can tell you more about getting an
          IUD/implant. Alternatively, we recommend using barrier contraception (such as condoms) as well
          as the oral contraceptive pill.
        </p>

        <p className="text-gray-800 text-sm font-medium mb-6 leading-relaxed text-center">
          I confirm that I understand and agree to the above.
        </p>

        <form onSubmit={handleSubmit} className="w-full">
          <ul className="flex flex-col gap-3 mb-6 list-none p-0">
            {["I understand", "I don't wish to continue with GLP1 prescription"].map((option) => {
              const isSelected = selection === option;
              return (
                <li key={option}>
                  <label
                    onClick={() => setSelection(option)}
                    className={`block w-full border rounded-lg p-3 cursor-pointer text-sm text-center transition-all 
                    ${
                      isSelected
                        ? "border-blue-500 bg-blue-50 font-semibold"
                        : "border-sky-300 bg-white"
                    }`}
                  >
                    {option}
                  </label>
                </li>
              );
            })}
          </ul>

          <button
            type="submit"
            disabled={!selection}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !selection
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </form>

        {showModal && (
          <Step3No
            onClose={handleCloseModal} 
            formData={formData}
            setFormData={setFormData}
          />
        )}
      </FormLayout>
    </>
  );
}
